import { render, staticRenderFns } from "./InformesMenu.vue?vue&type=template&id=366fa998&scoped=true&"
import script from "./InformesMenu.vue?vue&type=script&lang=ts&"
export * from "./InformesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./InformesMenu.vue?vue&type=style&index=0&id=366fa998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366fa998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('366fa998', component.options)
    } else {
      api.reload('366fa998', component.options)
    }
    module.hot.accept("./InformesMenu.vue?vue&type=template&id=366fa998&scoped=true&", function () {
      api.rerender('366fa998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/partes/InformesMenu.vue"
export default component.exports